export default __webpack_public_path__ + "static/media/error.321768c2.svg";